import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { colors } from '../theme/theme';

export const StyledDatePicker = styled(Stack)(({ theme }) => ({
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        backgroundColor: '#fff',
        '& fieldset': {
            borderColor: theme.palette.grey[300],
        },
        '&:hover fieldset': {
            borderColor: colors.primaryLight[100],
        },
        '&.Mui-focused fieldset': {
            borderColor: colors.primaryLight[100],
            borderWidth: '1px',
        },
    },
    '& .MuiInputBase-input': {
        ...theme.typography.body2,
        padding: '12px 8px',
        [theme.breakpoints.down('md')]: {
            fontSize: 16,
        },
    },
    '& .MuiInputAdornment-root svg': {
        color: colors.warningPreset[20],
    },
    '& .textFieldTitle': {
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(0.5),
    },
    '& .helperTitle': {
        color: colors.bluePreset[30],
        marginTop: theme.spacing(0.5),
    },
    '& .errorTxt': {
        color: colors.errorPreset[10],
        marginTop: theme.spacing(0.5),
    },
    '& .MuiButtonBase-root': {
        '& span': {
            color: colors.warningPreset[20],
        },
    },
    '& .MuiFormLabel-root': {
        ...theme.typography.body2,
        top: -4,
        '&.MuiInputLabel-shrink': {
            fontWeight: 400,
            lineHeight: 'normal',
            top: 1,
        },
    },
}));
